import React from 'react'
import styled from 'styled-components'
import Card from './Card'
import Title from './Title'
import media from '../../utils/media'

const Wrapper = styled.div`
  position: relative;
  width: 100vw;
  max-width: 1440px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  .section-title {
    margin-bottom: 60px;
    ${media.mobileL`
      padding: 0 15px;
      margin-bottom: 30px;
    `}
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: ${props => props.marginBCont}px;
  ${media.laptop`
    justify-content: center;
  `}
  ${media.mobileL`
    padding-right: 15px;
    padding-left: 15px;
    margin-bottom: calc(${props => props.marginBCont}px/4);
  `}
`

export default function Cards({ config }) {
  const {
    title,
    marginBCont,
    items,
    marginBTitle,
    cardWidth,
    eyeBrowFSize,
    titleFSize,
    titleFamily,
    mobileMargins,
    noBtn,
  } = config

  return (
    <Wrapper>
      <Title title={title} marginBTitle={marginBTitle} />
      <Container marginBCont={marginBCont}>
        {items.map(card => {
          return (
            <Card
              cardWidth={cardWidth}
              eyeBrowFSize={eyeBrowFSize}
              titleFSize={titleFSize}
              titleFamily={titleFamily}
              mobileMargins={mobileMargins}
              noBtn={noBtn}
              key={card.title}
              src={card.src}
              alt={card.alt}
              maxWidth={card.maxWidth}
              minWidth={card.minWidth}
              marginB={card.marginB}
              eyeBrow={card.eyeBrow}
              title={card.title}
              btnText={noBtn && card.btnText}
              href={card.href && card.href}
              btnBg={noBtn && card.btnBg}
              btnColor={noBtn && card.btnColor}
              btnMarginT={noBtn && card.btnMarginT}
              btnMarginB={noBtn && card.btnMarginB}
            />
          )
        })}
      </Container>
    </Wrapper>
  )
}
